/* =========================================================
   Plantive Mission - JS (Optimized OOP)
========================================================= */
document.addEventListener('DOMContentLoaded', () => {
  
  // จัดการการทำงานแบบ Object-Oriented รองรับ Section ซ้ำ
  const missionSections = document.querySelectorAll('.pm-outer-wrap');

  missionSections.forEach(sectionWrap => {
    
    // --- 1. Text Animation Observer ---
    const observer = new IntersectionObserver((entries, obs) => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          entry.target.classList.add('is-visible');
          obs.unobserve(entry.target); 
        }
      });
    }, { threshold: 0.2 }); 
    observer.observe(sectionWrap);

    // --- 2. Apple-Style Video Player Logic ---
    const videoWrapper = sectionWrap.querySelector('.pm-video-wrapper');
    if (!videoWrapper) return;

    const video = videoWrapper.querySelector('video.pm-video');
    if (video) {
      const playBtn = videoWrapper.querySelector('.pm-play-pause-btn');
      const muteBtn = videoWrapper.querySelector('.pm-mute-btn');
      
      const uiAutoplaySetting = videoWrapper.dataset.autoplay === 'true';
      const isDesktop = window.innerWidth > 990;

      // Autoplay: เล่นเฉพาะ Desktop ที่ติ๊กตั้งค่าไว้
      if (isDesktop && uiAutoplaySetting) {
        video.muted = true;
        video.play().then(() => {
          videoWrapper.classList.add('is-playing');
        }).catch(err => console.log("Autoplay prevented:", err));
      } else {
        video.pause();
        video.muted = true; 
        videoWrapper.classList.remove('is-unmuted'); 
      }

      const togglePlay = (e) => {
        if(e) e.stopPropagation();
        if (video.paused || video.ended) {
          video.play();
        } else {
          video.pause();
        }
      };

      playBtn.addEventListener('click', togglePlay);
      video.addEventListener('click', togglePlay);

      muteBtn.addEventListener('click', (e) => {
        e.stopPropagation();
        video.muted = !video.muted;
      });

      video.addEventListener('volumechange', () => {
        if (video.muted || video.volume === 0) {
          videoWrapper.classList.remove('is-unmuted'); 
        } else {
          videoWrapper.classList.add('is-unmuted'); 
        }
      });

      video.addEventListener('play', () => {
        videoWrapper.classList.add('is-playing');
        videoWrapper.classList.remove('is-ended');
      });
      video.addEventListener('pause', () => {
        videoWrapper.classList.remove('is-playing');
      });
      video.addEventListener('ended', () => {
        videoWrapper.classList.remove('is-playing');
        videoWrapper.classList.add('is-ended');
      });
    }

  });

  // --- 3. Global Scroll Scale Animation ---
  // ใช้ Event Scroll ของ Window เพียงตัวเดียวเพื่อปรับขนาด Video ทุกตัวในหน้า (ลดการกินทรัพยากรเครื่อง)
  let isTicking = false;
  const allVideoWrappers = document.querySelectorAll('.pm-video-wrapper');

  function scaleVideosOnScroll() {
    allVideoWrappers.forEach(videoWrapper => {
      const rect = videoWrapper.getBoundingClientRect();
      const viewportHeight = window.innerHeight;
      const elementCenter = rect.top + (rect.height / 2);
      const viewportCenter = viewportHeight / 2;
      const distanceFromCenter = Math.abs(viewportCenter - elementCenter);
      const maxDistance = viewportHeight * 0.45;

      let progress = 1 - (distanceFromCenter / maxDistance);
      progress = Math.max(0, Math.min(1, progress));

      const isMobile = window.innerWidth <= 990;
      const minScale = isMobile ? 0.9 : 0.65; 
      const currentScale = minScale + ((1 - minScale) * progress);
      
      const maxRadius = isMobile ? 32 : 60; 
      const minRadius = isMobile ? 16 : 24;
      const currentRadius = maxRadius - ((maxRadius - minRadius) * progress);

      videoWrapper.style.transform = `scale(${currentScale}) translateZ(0)`;
      videoWrapper.style.borderRadius = `${currentRadius}px`;
    });
    isTicking = false;
  }

  // เรียกใช้ครั้งแรกตอนโหลด
  if(allVideoWrappers.length > 0) {
    scaleVideosOnScroll();
    window.addEventListener('scroll', function() {
      if (!isTicking) {
        window.requestAnimationFrame(scaleVideosOnScroll);
        isTicking = true;
      }
    }, { passive: true }); // passive: true ช่วยให้ Scroll ลื่นขึ้น
  }

});